import React from 'react'
import { Lightbulb } from 'lucide-react'

/**
 * MicroHero - Mobile-only explainer section
 * Provides context before showing technical demos
 * Progressive disclosure: tells users what to expect
 * Brand-aligned: Orange accent with light→dark transition
 */
const MicroHero: React.FC = () => {
  return (
    <section className="bg-orange-50/50 border-y border-orange-200/40 py-6 px-4 mb-6 shadow-sm">
      <div className="max-w-2xl mx-auto text-center">
        {/* Icon with subtle shadow */}
        <div className="flex justify-center mb-3">
          <div className="bg-gradient-to-br from-orange-100 to-orange-50 rounded-full p-3 shadow-md border border-orange-200/50">
            <Lightbulb className="w-6 h-6 text-orange-600" />
          </div>
        </div>

        {/* Heading */}
        <h3 className="text-lg font-semibold text-slate-900 mb-2">
          How it works
        </h3>

        {/* Explainer with strikethrough and orange accent */}
        <p className="text-slate-700 text-sm leading-relaxed mb-3">
          See code examples with instant insights that connect to languages you already know<span className="text-orange-600 font-semibold">.</span> No <span className="line-through decoration-orange-500/60 decoration-2">memorization</span> needed<span className="text-orange-600 font-semibold">.</span>
        </p>

        {/* CTA hint */}
        <p className="text-orange-700 text-xs font-medium">
          👇 Swipe through examples below
        </p>
      </div>
    </section>
  )
}

export default MicroHero
